import { Component, input, ChangeDetectionStrategy } from '@angular/core';

import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { NgbDropdown, NgbDropdownMenu, NgbDropdownToggle } from '@ng-bootstrap/ng-bootstrap';
import { OSSupportedPipe } from '../../../pipes/os-supported.pipe';
import { RestartDeviceDropdownItemComponent } from '../../../sub-features/device-admin/commands/restart-device/restart-device-dropdown-item.component';
import { ShutdownDeviceDropdownItemComponent } from '../../../sub-features/device-admin/commands/shutdown-device/shutdown-device-dropdown-item.component';
import { AppleDevice } from '../../../viewmodels/apple/apple-device.model';

@Component({
  selector: 'ml-mdm-apple-device-power-ui',
  templateUrl: './apple-device-power.component.html',
  styleUrls: ['./apple-device-power.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    NgbDropdown,
    NgbDropdownToggle,
    FaIconComponent,
    NgbDropdownMenu,
    RestartDeviceDropdownItemComponent,
    ShutdownDeviceDropdownItemComponent,
    OSSupportedPipe,
  ],
})
export class AppleDevicePowerComponent {
  readonly apple = input<AppleDevice | undefined>(undefined);
  readonly class = input<string | undefined>(undefined);
}
